module.exports = "https://pm2019.reeltime.no/public/images/pm_logo_new_text@2x.67f2eb7c.png";